// extracted by mini-css-extract-plugin
export default {"root":"Page_root__4Hn1z","errMsg":"Page_errMsg__Hr6zv","infoMsg":"Page_infoMsg__wx00Y"};